module.exports = __webpack_public_path__ + "img/1.e1c0f658.jpg";